// extracted by mini-css-extract-plugin
module.exports = {"nestedTabContainer":"style_nestedTabContainer__3wvsX"};